import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

async function deleteNewResponseCode(id: number): Promise<any> {
  const { data } = await axiosInstance.delete(`/ResponseCode/DeleteNewResponseCode?id=${id}`);
  return data;
}

export function useDeleteNewResponseCode() {
  const queryClient = useQueryClient();
  return useMutation((id: number) => deleteNewResponseCode(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.newResponseCodes);
    },
  });
}
